var map = {
	"./cald_1.png": "OFV/",
	"./cald_2.png": "L4GY"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Kjk5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons ^\.\/cald_.*\.png$
// module id = Kjk5
// module chunks = 0